import { useEffect, useState } from 'react'
import throttle from 'lodash/throttle'

const SCROLL_THROTTLE_MS = 100

export const useHasScrolledPastViewport = (): boolean => {
  const [hasScrolledPast, setHasScrolledPast] = useState(false)

  useEffect(() => {
    const handleScroll = throttle(() => {
      setHasScrolledPast(globalThis.scrollY > globalThis.innerHeight)
    }, SCROLL_THROTTLE_MS)

    globalThis.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      handleScroll.cancel()
      globalThis.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return hasScrolledPast
}
